<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-body">
      <i class="flaticon-cancel-12 close" (click)="cancel()"></i>
      <div class="add-contact-box">
        <div class="add-contact-content">
          <h5 class="text-center mb-4">{{ 'edituser' | translate }}</h5>
          <form style="display: flex; flex-direction: column; gap: 20px">
            <div class="row">
              <div class="col-md-12" style="margin-top: 20px">
                <div class="contact-name">
                  <i class="las la-user"></i>
                  <input
                    [(ngModel)]="user.name"
                    type="text"
                    name="name"
                    #name="ngModel"
                    id="c-name"
                    class="form-control"
                    [class.is-invalid]="
                      name.invalid && (name.dirty || name.touched)
                    "
                    placeholder="{{ 'login.name' | translate }}"
                    required
                  />
                  <div
                    class="error-field"
                    *ngIf="name.invalid && (name.dirty || name.touched)"
                  >
                    <span *ngIf="name.errors?.required">{{
                      'validation.required' | translate
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="col-md-12" style="margin-top: 20px">
                <div class="contact-name">
                  <i class="las la-user"></i>
                  <input
                    [(ngModel)]="user.userName"
                    (change)="changeUserName()"
                    type="text"
                    name="userName"
                    #userName="ngModel"
                    id="c-userName"
                    class="form-control"
                    [class.is-invalid]="
                      (userName.invalid &&
                        (userName.dirty || userName.touched)) ||
                      duplicateUserNameError
                    "
                    placeholder="{{ 'login.username' | translate }}"
                    required
                  />
                  <div
                    class="error-field"
                    *ngIf="
                      userName.invalid && (userName.dirty || userName.touched)
                    "
                  >
                    <span *ngIf="userName.errors?.required">{{
                      'validation.required' | translate
                    }}</span>
                  </div>
                  <div class="error-field" *ngIf="duplicateUserNameError">
                    <span>{{ 'userNameTaken' | translate }}</span>
                  </div>
                </div>
              </div>
              <div class="col-md-12" style="margin-top: 20px">
                <div class="contact-email">
                  <i class="las la-envelope"></i>
                  <input
                    [(ngModel)]="user.email"
                    (change)="changeEmail()"
                    type="email"
                    name="email"
                    #email="ngModel"
                    id="c-email"
                    class="form-control"
                    [class.is-invalid]="
                      (email.invalid && (email.dirty || email.touched)) ||
                      duplicateEmailError
                    "
                    placeholder="{{ 'login.email' | translate }}"
                    required
                    pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                  />
                  <div
                    class="error-field"
                    *ngIf="email.invalid && (email.dirty || email.touched)"
                  >
                    <span *ngIf="email.errors?.required">{{
                      'validation.required' | translate
                    }}</span>
                    <span *ngIf="email.errors?.pattern">{{
                      'validation.invalidEmail' | translate
                    }}</span>
                  </div>
                  <div class="error-field" *ngIf="duplicateEmailError">
                    <span>{{ 'emailTaken' | translate }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="contact-contact">
                  <i class="las la-phone"></i>
                  <input
                    [(ngModel)]="user.phone"
                    name="contact"
                    #phone="ngModel"
                    type="text"
                    id="c-contact"
                    class="form-control number-input"
                    [class.is-invalid]="
                      phone.invalid && (phone.dirty || phone.touched)
                    "
                    placeholder="{{ 'login.phone' | translate }}"
                    required
                    pattern="^\d{6,10}$"
                  />
                  <div
                    class="error-field"
                    *ngIf="phone.invalid && (phone.dirty || phone.touched)"
                  >
                    <span *ngIf="phone.errors?.required">{{
                      'validation.required' | translate
                    }}</span>
                    <span *ngIf="phone.errors?.pattern">{{
                      'validation.invalidPhone' | translate
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="contact-location">
                  <i class="las la-map-marker"></i>
                  <ng-select
                    class="selectpicker"
                    name="profile"
                    #role="ngModel"
                    [closeOnSelect]="true"
                    placeholder="{{ 'login.profile' | translate }}"
                    [(ngModel)]="this.user['idRolUser']"
                    [class.is-invalid]="
                      role.invalid && (role.dirty || role.touched)
                    "
                    required
                  >
                    <ng-option *ngFor="let role of roles" [value]="role.id">
                      {{ 'roles.' + role.name | translate }}
                    </ng-option>
                  </ng-select>
                  <div
                    class="error-field"
                    *ngIf="role.invalid && (role.dirty || role.touched)"
                  >
                    <span *ngIf="role.errors?.required">{{
                      'validation.required' | translate
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="contact-location">
                  <i class="las la-map-marker"></i>
                  <ng-select
                    class="selectpicker"
                    name="companies"
                    #company="ngModel"
                    [items]="companies"
                    bindLabel="name"
                    bindValue="id"
                    (ngModelChange)="companyChanged($event)"
                    [closeOnSelect]="true"
                    placeholder="{{ 'login.company' | translate }}"
                    [(ngModel)]="this.user['idCompany']"
                    [class.is-invalid]="
                      company.invalid && (company.dirty || company.touched)
                    "
                    required
                  ></ng-select>
                  <div
                    class="error-field"
                    *ngIf="
                      company.invalid && (company.dirty || company.touched)
                    "
                  >
                    <span *ngIf="company.errors?.required">{{
                      'validation.required' | translate
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="contact-location">
                  <i class="las la-map-marker"></i>
                  <ng-select
                    class="selectpicker"
                    name="departments"
                    [items]="departments"
                    [closeOnSelect]="true"
                    placeholder="{{ 'login.department' | translate }}"
                    [(ngModel)]="this.user['department']"
                  ></ng-select>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <a class="pointer text-primary font-12 mr-3" (click)="cancel()">{{
        'cancel' | translate
      }}</a>
      <button
        class="btn btn-sm btn-primary"
        (click)="save()"
        *ngIf="!isLoading"
        [disabled]="!canSave"
      >
        <span>
          {{ 'submit' | translate }}
        </span>
      </button>
      <button
        class="btn btn-sm btn-prim btn-loading"
        style="min-width: 140px"
        *ngIf="isLoading"
      >
        <span *ngIf="isLoading" class="loader-btn"></span>
      </button>
    </div>
  </div>
</div>
